import { Button, Tag } from "antd"
import { DeleteOutlined, CheckOutlined } from "@ant-design/icons"
import { Text } from "ui/Typography"
import styles from "./index.module.css"

/**
 * Table column configuration for experiences (desktop view)
 * @param {Function} onRemoveExperience - Callback to handle experience removal
 */
export const getExperienceTableColumns = (onRemoveExperience) => [
  {
    title: "Experience",
    dataIndex: "name",
    key: "name",
    render: (name) => <Text fw="500">{name}</Text>
  },
  {
    title: "Guests",
    dataIndex: "guests",
    key: "guests",
    align: "left",
    render: (guests) => <Text>{guests}</Text>
  },
  {
    title: "Price",
    key: "price",
    align: "right",
    render: (_, record) => (
      <Text fw="400">
        {record.currency}
        {record.price.toFixed(2)}
      </Text>
    )
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    align: "left",
    render: (status) => {
      const isPublished = String(status).toLowerCase() === "published"
      const displayText = String(status).charAt(0).toUpperCase() + String(status).slice(1)
      return (
        <Tag color={isPublished ? "green" : "default"} icon={isPublished ? <CheckOutlined /> : null}>
          {displayText}
        </Tag>
      )
    }
  },
  {
    title: "",
    key: "action",
    align: "right",
    render: (_, record) => (
      <Button
        type="text"
        icon={<DeleteOutlined className={styles.deleteIcon} color="#525455" />}
        onClick={() => onRemoveExperience(record.id)}
        className={styles.removeExperienceButton}
        aria-label="Remove experience"
      />
    )
  }
]

/**
 * Returns modal title and submit button text based on mode
 */
export const getModalConfig = (isDuplicateMode, isEditMode, t) => ({
  title: isDuplicateMode
    ? t("equipment.duplicate_equipment", { defaultValue: "Duplicate Equipment" })
    : isEditMode
    ? t("equipment.edit_equipment", { defaultValue: "Edit Equipment" })
    : t("equipment.add_equipment"),
  submitButtonText: isDuplicateMode
    ? t("common.create", { defaultValue: "Create" })
    : isEditMode
    ? t("common.update", { defaultValue: "Save Changes" })
    : t("common.save")
})
